import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { uiActions } from "store/ui/ui-slice";
import { clearAuthToken } from "utils/auth";

const TokenExpirationHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleTokenExpired = () => {
      clearAuthToken();
      dispatch(
        uiActions.updateNotification({
          message: "Your session has expired. Please log in again.",
          level: "error",
        })
      );
      navigate("/login", { replace: true });
    };

    window.addEventListener("authTokenExpired", handleTokenExpired);

    return () => {
      window.removeEventListener("authTokenExpired", handleTokenExpired);
    };
  }, [dispatch, navigate]);

  return null;
};

export default TokenExpirationHandler;
